module.exports = __webpack_public_path__ + "static/media/guide_modern.81d77c88.png";